module.exports = __webpack_public_path__ + "static/media/Alerts.ab3d38c5.svg";